import React, { Component } from 'react';
import {
	Modal,
	Button,
	Form,
	FormGroup,
	FormControl,
	Row,
	Col,
	ControlLabel,
	Alert
} from 'react-bootstrap';
import { setWeightColor} from '../../actions';


class SectorWeightColorModal extends Component {

	constructor(props) {
		super(props);
		// console.log(this.props.customizations)
		this.state = {
			green: this.props.customizations[0].tickerWeightGreen,
			red: this.props.customizations[0].tickerWeightRed,
			error: ''
		};

	}

	renderAlert = () => {
		if (this.state.error) {
			return (
				<Alert bsStyle="danger">
					<strong>Oops!</strong> {this.state.error}
				</Alert>
			);
		}
	}
	//
	// onNewPortfolio = () => {
	// 	const { green, red } = this.state;
	// 		this.props.createNewPortfolio({
	// 			name: name,
	// 			accountHolder: accountHolder,
	// 			accountNumber: accountNumber
	// 		});
	// 		this.closeModal();
	//
	// }
	saveWeightColors = ()=>{

		setWeightColor(this.state.red,this.state.green);
		this.closeModal()
}

	closeModal = () => {
		this.props.closeModal('showSectorWeightSetModal');
	}


	render() {
		return (
			<Modal show={this.props.showSectorWeightSetModal} onHide={() => this.closeModal()} className="new-portfolio-modal">
				<Modal.Header closeButton>
					<Modal.Title>Set Weight Colour Threshold</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col mdOffset={2} md={8}>
							<Form onSubmit={(e) => e.preventDefault()}>
								<FormGroup controlId="green">
									<ControlLabel>Green if weight is greater than:</ControlLabel>
									<FormControl
										type="text"
										placeholder=""
										value={this.state.green}
										name="green"
										onChange={(e) => this.setState({ [e.target.name]: e.target.value })} />
								</FormGroup>
								<FormGroup controlId="red">
									<ControlLabel>Red if weight is less than</ControlLabel>
									<FormControl
										type="text"
										value={this.state.red}
										name="red"
										onChange={(e) => this.setState({ [e.target.name]: e.target.value })} />
								</FormGroup>

								{this.renderAlert()}
								<Button
									className="new-portfolio-btn btn-blue"
									bsStyle="primary"
									onClick={() => this.saveWeightColors()}
								>Save</Button>
							</Form>
						</Col>
					</Row>

				</Modal.Body>
				<Modal.Footer>
					<Button
						bsStyle="default"
						onClick={() => this.closeModal()}
					>Close</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

export default SectorWeightColorModal;